import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import { useAppMeta } from "hooks";
import {
  useGetAccountLedgerDetailQuery,
  useUpdateAccountLedgerMutation,
} from "store/services/accountLedgerApi";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import AccountLedgerForm from "./accountLedgerComponents/AccountLedgerForm";

const breadcrumbs = [
  { title: "Account Ledger", path: "/app/crm/account-ledger/list" },
  { title: "Edit Account Ledger" },
];
const AccountLedgerEditScreen = () => {
  const { id } = useParams();

  const navigate = useNavigate();

  const { data: accountLedgerDetail, isLoading: accountLedgerLoading } =
    useGetAccountLedgerDetailQuery(id);

  // RTK Query
  const [updateAccountLedger, { isLoading: updatingAccountLedger }] =
    useUpdateAccountLedgerMutation();

  // methods
  const handleAccountLedgerUpdate = async (data) => {
    try {
      await updateAccountLedger(data).unwrap();
      navigate(`/app/crm/account-ledger/${id}/detail`);
      toast.success("Account Ledger successfully updated!");
    } catch (err) {
      toast.error(err?.data?.message ?? "Couldn't update Account Ledger!");
    }
  };

  useAppMeta("Edit Account Ledger");

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs}>
      <BreadcrumbLayout.Paper>
        <AccountLedgerForm
          accountLedgerDetail={accountLedgerDetail}
          isBusy={accountLedgerLoading || updatingAccountLedger}
          onSubmit={handleAccountLedgerUpdate}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default AccountLedgerEditScreen;
